import styled from 'styled-components';

type ProgressHeaderProps = {
  progress: number;
  title: string;
}

type AlignType = 'left' | 'center' | 'right';

const Container = styled.div`
  max-width: 100%;
  width: calc(80 * var(--base-unit, 8px));
  box-sizing: border-box;
  padding: 18px 26px 22px;
  border-radius: 0 0 20px 20px;
  background-color: #F6F6F8;
  box-shadow: 0px 2px 4px 0px #00000014;
`;

const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ProgressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const LabelsRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ProgressBar = styled.div`
  flex: 1;
  height: 10px;
  background-color: #fff;
  position: relative;
  border-radius: 100px;
`;

const Indicator = styled.div<{ progress: number }>`
  height: 100%;
  background-color: #406EDF;
  width: ${props => props.progress}%;
  border-radius: 100px;
`;

const IconWrapper = styled.div`
  width: 25px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const IconLabel = styled.span<{ align: AlignType, isBold?: boolean }>`
  font-family: Lato, sans-serif;
  font-size: 16px;
  line-height: 16px;
  color: #000000;
  white-space: normal;
  text-align: ${props => props.align};
  flex: 1;
  min-width: 0;
  font-weight: ${props => props.isBold ? 'bold' : 'normal'};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const Icon0 = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.2383" cy="12" r="12" fill="white"/>
    <circle cx="12.1621" cy="11.9243" r="10" fill="#0B6DFF"/>
  </svg>
);

const Icon50 = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.738281" width="24" height="23.9766" rx="11.9883" fill="white"/>
    <g clip-path="url(#clip0_8456_1041)">
      <path d="M15.2164 9.47498C14.6489 8.90654 14.0384 8.38283 13.3902 7.90851C13.8335 7.64062 14.2987 7.41069 14.7808 7.22118C14.9087 7.17323 15.0286 7.13726 15.1485 7.1013C15.2457 7.21898 15.371 7.31034 15.5128 7.36697C15.6546 7.42359 15.8084 7.44368 15.9599 7.42538C16.1115 7.40708 16.2561 7.35098 16.3803 7.26223C16.5046 7.17348 16.6045 7.05493 16.671 6.91748C16.9564 6.94303 17.2257 7.06087 17.4382 7.25315C17.9138 7.72869 17.9257 8.68775 17.4782 9.88258C17.674 10.1423 17.8538 10.4061 18.0177 10.6818C18.0856 10.522 18.1575 10.3661 18.2135 10.2103C18.8009 8.67176 18.725 7.41299 18.0017 6.70169C17.6396 6.35931 17.1684 6.15555 16.671 6.12625C16.588 5.9532 16.4526 5.81064 16.2842 5.71872C16.1157 5.62679 15.9226 5.59017 15.7321 5.61403C15.5417 5.63789 15.3636 5.72103 15.223 5.85167C15.0824 5.98232 14.9864 6.15386 14.9487 6.34204C14.8008 6.386 14.6529 6.42996 14.4971 6.4899C13.8588 6.74185 13.2471 7.05641 12.6709 7.42898C12.094 7.05065 11.4809 6.73072 10.8407 6.47391C9.30218 5.89048 8.04341 5.96241 7.3361 6.68571C6.67275 7.35305 6.56485 8.45997 7.00442 9.82664C6.9041 9.95564 6.84032 10.1093 6.81977 10.2714C6.79922 10.4335 6.82265 10.5982 6.88762 10.7482C6.95259 10.8981 7.0567 11.0278 7.18904 11.1237C7.32137 11.2196 7.47707 11.2782 7.6398 11.2932C7.76768 11.537 7.90754 11.7807 8.06339 12.0205C7.69219 12.5977 7.38025 13.2108 7.1323 13.8507C6.54487 15.3852 6.6208 16.648 7.34409 17.3553C7.56415 17.5609 7.82327 17.7203 8.10608 17.824C8.38889 17.9276 8.68964 17.9734 8.99048 17.9587C9.62886 17.9382 10.2583 17.8029 10.8487 17.5591C11.4883 17.3074 12.1014 16.9928 12.6789 16.62C13.2516 17.0004 13.8607 17.323 14.4971 17.5831C14.9652 17.767 15.4557 17.888 15.9557 17.9427C16.0434 18.1293 16.1914 18.281 16.3758 18.3734C16.5603 18.4657 16.7704 18.4934 16.9724 18.4519C17.1744 18.4104 17.3566 18.3021 17.4897 18.1445C17.6227 17.9869 17.6989 17.7892 17.706 17.5831C17.812 17.5174 17.9111 17.441 18.0017 17.3553C18.725 16.632 18.8009 15.3852 18.2135 13.8507C17.5241 12.2026 16.504 10.7133 15.2164 9.47498ZM10.557 16.8198C9.35812 17.2793 8.37908 17.2714 7.89955 16.7878C7.42002 16.3043 7.40803 15.3412 7.87158 14.1344C8.0598 13.6525 8.28839 13.1873 8.55491 12.7438C9.0306 13.3896 9.55424 13.9988 10.1214 14.566C10.2932 14.7378 10.469 14.9057 10.6449 15.0655C10.8846 14.943 11.1284 14.8031 11.3762 14.6459C11.1444 14.4381 10.9126 14.2463 10.6888 14.0026C9.78942 13.1188 9.01743 12.1141 8.39506 11.0175C8.52005 10.8879 8.60405 10.7244 8.63656 10.5474C8.66908 10.3703 8.64865 10.1876 8.57785 10.0221C8.50704 9.85663 8.389 9.71569 8.2385 9.61695C8.088 9.51821 7.91171 9.46604 7.73171 9.46699C7.43201 8.46796 7.48396 7.67274 7.90355 7.25315C8.05133 7.12291 8.22352 7.02334 8.41011 6.96023C8.59671 6.89712 8.79399 6.87172 8.99048 6.88551C9.52972 6.90352 10.0615 7.01718 10.5609 7.22118C11.043 7.41069 11.5082 7.64062 11.9516 7.90851C11.3034 8.38283 10.6928 8.90654 10.1254 9.47498C9.94955 9.65081 9.77771 9.83463 9.60988 10.0184C9.73002 10.2717 9.86341 10.5185 10.0095 10.7577C10.2253 10.514 10.4451 10.2742 10.6808 10.0384C11.2956 9.42424 11.9643 8.86654 12.6789 8.37206C13.3856 8.86867 14.0475 9.42626 14.6569 10.0384C15.2711 10.6532 15.8288 11.3219 16.3233 12.0365C15.8276 12.7502 15.27 13.4188 14.6569 14.0345C13.494 15.2322 12.0989 16.18 10.557 16.8198ZM17.4382 16.7838L17.3743 16.8358C17.2693 16.7468 17.1456 16.6829 17.0123 16.6489C16.879 16.6148 16.7397 16.6115 16.6049 16.6392C16.4702 16.6669 16.3435 16.7249 16.2345 16.8088C16.1255 16.8927 16.037 17.0003 15.9757 17.1235C15.5649 17.0706 15.1623 16.9673 14.7768 16.8158C14.2939 16.6281 13.8286 16.3981 13.3862 16.1285C14.0344 15.6542 14.6449 15.1304 15.2124 14.562C15.7819 13.9969 16.3057 13.3876 16.7789 12.7398C17.0468 13.1831 17.2767 13.6483 17.4662 14.1304C17.9218 15.3412 17.9218 16.3083 17.4382 16.7838Z" fill="#0B6DFF"/>
      <path d="M12.9352 13.3159C13.6541 13.1992 14.1423 12.5218 14.0256 11.8029C13.9089 11.084 13.2315 10.5958 12.5126 10.7125C11.7937 10.8292 11.3055 11.5066 11.4222 12.2255C11.5389 12.9444 12.2163 13.4326 12.9352 13.3159Z" fill="#0B6DFF"/>
    </g>
    <defs>
      <clipPath id="clip0_8456_1041">
        <rect width="14.3859" height="14.3859" fill="white" transform="translate(5.5332 4.79541)"/>
      </clipPath>
    </defs>
  </svg>
);

const Icon50Filled = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="24" height="23.9766" rx="11.9883" fill="#0B6DFF"/>
    <g clip-path="url(#clip0_8588_5029)">
      <path d="M14.9781 9.47449C14.4107 8.90606 13.8001 8.38234 13.1519 7.90802C13.5953 7.64013 14.0605 7.41021 14.5425 7.22069C14.6704 7.17274 14.7903 7.13678 14.9102 7.10081C15.0075 7.2185 15.1327 7.30985 15.2745 7.36648C15.4163 7.42311 15.5701 7.44319 15.7217 7.42489C15.8732 7.40659 16.0178 7.35049 16.142 7.26174C16.2663 7.17299 16.3662 7.05445 16.4327 6.91699C16.7181 6.94254 16.9875 7.06038 17.1999 7.25266C17.6755 7.7282 17.6875 8.68726 17.2399 9.88209C17.4357 10.1418 17.6155 10.4056 17.7794 10.6813C17.8473 10.5215 17.9192 10.3656 17.9752 10.2098C18.5626 8.67128 18.4867 7.41251 17.7634 6.7012C17.4013 6.35882 16.9301 6.15506 16.4327 6.12576C16.3497 5.95272 16.2144 5.81015 16.0459 5.71823C15.8774 5.62631 15.6843 5.58969 15.4938 5.61355C15.3034 5.63741 15.1253 5.72054 14.9847 5.85118C14.8441 5.98183 14.7481 6.15338 14.7104 6.34155C14.5625 6.38551 14.4147 6.42947 14.2588 6.48941C13.6206 6.74136 13.0088 7.05593 12.4326 7.42849C11.8558 7.05017 11.2427 6.73023 10.6024 6.47342C9.0639 5.88999 7.80513 5.96192 7.09782 6.68522C6.43447 7.35257 6.32657 8.45948 6.76614 9.82615C6.66582 9.95516 6.60204 10.1088 6.58149 10.2709C6.56094 10.433 6.58437 10.5977 6.64934 10.7477C6.71431 10.8976 6.81842 11.0274 6.95076 11.1232C7.08309 11.2191 7.23879 11.2777 7.40152 11.2927C7.5294 11.5365 7.66926 11.7802 7.82511 12.02C7.45391 12.5972 7.14196 13.2103 6.89402 13.8502C6.30659 15.3847 6.38252 16.6475 7.10581 17.3548C7.32587 17.5605 7.58499 17.7198 7.8678 17.8235C8.15061 17.9271 8.45136 17.9729 8.7522 17.9582C9.39058 17.9377 10.02 17.8024 10.6104 17.5586C11.25 17.3069 11.8631 16.9923 12.4406 16.6195C13.0133 16.9999 13.6224 17.3225 14.2588 17.5826C14.7269 17.7666 15.2174 17.8875 15.7174 17.9422C15.8052 18.1289 15.9532 18.2805 16.1376 18.3729C16.322 18.4652 16.5321 18.4929 16.7341 18.4514C16.9361 18.4099 17.1183 18.3016 17.2514 18.144C17.3844 17.9864 17.4606 17.7887 17.4677 17.5826C17.5737 17.5169 17.6728 17.4405 17.7634 17.3548C18.4867 16.6315 18.5626 15.3847 17.9752 13.8502C17.2858 12.2021 16.2657 10.7129 14.9781 9.47449ZM10.3187 16.8193C9.11984 17.2789 8.1408 17.2709 7.66127 16.7873C7.18174 16.3038 7.16975 15.3408 7.6333 14.1339C7.82152 13.652 8.05011 13.1868 8.31663 12.7433C8.79232 13.3891 9.31596 13.9983 9.8831 14.5655C10.0549 14.7373 10.2308 14.9052 10.4066 15.065C10.6463 14.9425 10.8901 14.8026 11.1379 14.6454C10.9061 14.4376 10.6743 14.2458 10.4505 14.0021C9.55114 13.1183 8.77915 12.1136 8.15678 11.017C8.28177 10.8874 8.36577 10.7239 8.39828 10.5469C8.43079 10.3698 8.41037 10.1871 8.33957 10.0216C8.26876 9.85614 8.15072 9.71521 8.00022 9.61646C7.84972 9.51772 7.67343 9.46555 7.49343 9.4665C7.19372 8.46747 7.24567 7.67225 7.66526 7.25266C7.81304 7.12243 7.98524 7.02286 8.17183 6.95974C8.35843 6.89663 8.5557 6.87123 8.7522 6.88502C9.29144 6.90303 9.82319 7.01669 10.3227 7.22069C10.8048 7.41021 11.27 7.64013 11.7133 7.90802C11.0651 8.38234 10.4546 8.90606 9.88709 9.47449C9.71126 9.65032 9.53943 9.83414 9.3716 10.018C9.49174 10.2712 9.62513 10.518 9.77121 10.7572C9.98699 10.5135 10.2068 10.2737 10.4425 10.0379C11.0573 9.42376 11.726 8.86606 12.4406 8.37157C13.1474 8.86818 13.8092 9.42577 14.4187 10.0379C15.0328 10.6527 15.5905 11.3214 16.085 12.036C15.5894 12.7497 15.0318 13.4183 14.4187 14.034C13.2557 15.2317 11.8606 16.1795 10.3187 16.8193ZM17.1999 16.7833L17.136 16.8353C17.0311 16.7463 16.9073 16.6824 16.774 16.6484C16.6407 16.6143 16.5014 16.611 16.3667 16.6387C16.2319 16.6665 16.1052 16.7245 15.9962 16.8084C15.8872 16.8923 15.7987 16.9999 15.7374 17.123C15.3266 17.0701 14.924 16.9668 14.5385 16.8153C14.0557 16.6276 13.5903 16.3976 13.1479 16.128C13.7961 15.6537 14.4067 15.13 14.9741 14.5615C15.5436 13.9964 16.0674 13.3871 16.5406 12.7393C16.8085 13.1826 17.0384 13.6479 17.2279 14.1299C17.6835 15.3408 17.6835 16.3078 17.1999 16.7833Z" fill="white"/>
      <path d="M12.6969 13.3149C13.4158 13.1982 13.904 12.5208 13.7873 11.8019C13.6706 11.083 12.9932 10.5949 12.2743 10.7116C11.5554 10.8283 11.0673 11.5056 11.1839 12.2245C11.3006 12.9434 11.978 13.4316 12.6969 13.3149Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_8588_5029">
        <rect width="14.3859" height="14.3859" fill="white" transform="translate(5.29492 4.79492)"/>
      </clipPath>
    </defs>
  </svg>
);

const Icon100 = () => (
  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.981445" width="24" height="24.0371" rx="12" fill="white"/>
    <path d="M6.80859 11.4975H18.2262M6.80859 11.4975V18.1077C6.80859 18.2671 6.87191 18.4199 6.9846 18.5326C7.0973 18.6453 7.25015 18.7086 7.40952 18.7086H17.6253C17.7847 18.7086 17.9375 18.6453 18.0502 18.5326C18.1629 18.4199 18.2262 18.2671 18.2262 18.1077V11.4975M6.80859 11.4975V8.79331C6.80859 8.63393 6.87191 8.48109 6.9846 8.36839C7.0973 8.25569 7.25015 8.19238 7.40952 8.19238H17.6253C17.7847 8.19238 17.9375 8.25569 18.0502 8.36839C18.1629 8.48109 18.2262 8.63393 18.2262 8.79331V11.4975" stroke="#0B6DFF" stroke-width="1.22" stroke-linejoin="round"/>
    <path d="M10.1133 15.1036L11.9161 16.9063L15.5216 13.3008" stroke="#0B6DFF" stroke-width="1.22" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.1133 7.29102V9.69473M14.9207 7.29102V9.69473" stroke="#0B6DFF" stroke-width="1.22" stroke-linecap="round"/>
  </svg>
);

const ProgressHeader: React.FC<ProgressHeaderProps> = ({ progress, title }) => {
  const firstHalfProgress = Math.min(progress * 2, 100);
  const secondHalfProgress = progress > 50 ? ((progress - 50) / 50) * 100 : 0;

  return (
    <Container>
      <ProgressContainer>
        <ProgressRow>
          <IconWrapper>
            <Icon0 />
          </IconWrapper>
          <ProgressBar>
            <Indicator progress={firstHalfProgress} />
          </ProgressBar>
          <IconWrapper>
            {progress < 50 ? <Icon50 /> : <Icon50Filled />}
          </IconWrapper>
          <ProgressBar>
            <Indicator progress={secondHalfProgress} />
          </ProgressBar>
          <IconWrapper>
            <Icon100 />
          </IconWrapper>
        </ProgressRow>
        <LabelsRow>
          <IconLabel align="left" isBold={progress < 50}>Getting Started</IconLabel>
          <IconLabel align="center" isBold={progress >= 50}>Goal Timeline</IconLabel>
          <IconLabel align="right">Personalized Plan</IconLabel>
        </LabelsRow>
      </ProgressContainer>
    </Container>
  );
};

export default ProgressHeader;
export type {
  ProgressHeaderProps,
}
